<template>
  <div class="commission-details" ref="container">

    <div class="my-promotion">
      <div class="header"style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div>累计提现</div>
        </div>
        <div class="num"><span  style="font-size:0.4rem;">已审:</span>{{extract_money || 0}} <span style="font-size:0.4rem;">待审:</span>{{extract_will_money || 0}}</div>
        <div class="name acea-row row-center-wrapper">
          <div>{{transfer_name}}余额</div>
        </div>
        <div class="num">{{commissionCount || 0}}</div>
      </div>
    </div>
    <div class="bill-details">
      <div class="nav acea-row">
        <div class="item"  @click="toCommissionList()" >
          提现
        </div>
        <div class="item on" >
          提现记录
        </div>
      </div>
    </div>


    <div class="sign-record sign-record1" ref="content">
      <div class="list" v-if="info.length > 0">
        <div class="item" v-for="(val, index) in info" :key="index">
          <!--<div class="data">{{ item.time }}</div>-->
          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                  <div class="name line1" style="color:red;" v-if="val.status == -1">{{val.extract_field_name}} {{ val.status_name }}</div>
                <div class="name line1"  v-if="val.status == 0">{{val.extract_field_name}} {{ val.status_name }}</div>
                  <div class="name line1" style="color:#16ac57;" v-if="val.status == 1">{{val.extract_field_name}} {{ val.status_name }}</div>
                <div class="name line1">手续费：{{val.all_fee_money}} 到账金额：{{val.get_money}}</div>
                <div class="name line1">{{val.bank_address}} 尾号：{{val.bank_code_last}}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num " style="color:#282828">
                {{ val.extract_price }}
              </div>
              <div style="clear:both;"></div>
              <div style="display:block;width:100%;" v-if="val.fail_msg">
                备注：{{ val.fail_msg }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .sign-record .list .item .listn .itemn .num {

    text-align: right;
  }
</style>
<script>
import { getBank,getExtractList } from "../../../api/user";
import Loading from "@components/Loading";

export default {
  name: "CashRecord",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      showno:1,
      info: [],
      commission: 0,
      post: {
        extract_field: '',
      },
      extract_money: 0,
      extract_will_money:0,
      commissionCount: 0,
      transfer_name:'',
      where: {
        page: 1,
        limit: 20
      },
      types: 4,
      loaded: false,
      loading: false
    };
  },
    watch: {
        $route(n) {
            if (n.name == "CashRecord") {
              if(this.$route.params.types){
                this.post.extract_field = this.$route.params.types;
              }
                this.where.page = 1;
                this.loaded = false;
                this.loading = false;
                this.info = [];
                this.getBank();
                this.getIndex();
            }
        }
    },
  mounted: function() {
    if(this.$route.params.types){
      this.post.extract_field = this.$route.params.types;
    }
    this.getBank();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    toCommissionList(){
      this.$router.push({path:'/user/user_cash/'+this.post.extract_field})
    },
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getExtractList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
          if(that.info.length==0){
            that.showno=0;
          }
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getBank: function() {
      let that = this;
      getBank().then(
        res => {
          if(that.post.extract_field==''){
            that.post.extract_field = res.data.extract_field;
          }
          that.extract_money = res.data.extract_money;
          that.extract_will_money = res.data.extract_will_money;
          that.transfer_name = res.data.transferType[that.post.extract_field];
          that.commissionCount = res.data.user[that.post.extract_field];
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
